import React, { useEffect, useMemo, useState } from "react";
import Container from "../components/Layout/Container";
import ContentBlock from "../components/Layout/ContentBlock";
import FilterMenu from "../components/Layout/FilterMenu";
import TableFilterBox from "../components/common/TableFilterBox";
import ContentValidation from "../components/common/ContentValidation";
import Pagination from "../components/Dashboard/items/Pagination";
import {
  antdMessageError,
  getDateFormat,
  prettyDateFormat,
  returnEuroString,
} from "../helpers/Utils";
import {
  ButtonDelete,
  ButtonSmall,
  CheckBoxInput,
  SelectForm,
} from "../components/common/Buttons";
import RangePickerComp from "../components/common/RangePickerComp";
import { Popconfirm, Tooltip } from "antd";
import ModalSpecial from "../components/Layout/Modals/ModalSpecial";
import {
  IconDot,
  IconDownload,
  IconEdit,
  IconSave,
  IconSearch,
  IconTimes,
  XIcon,
} from "../components/Layout/Icons";
import TableUi from "../components/Layout/TableUI";
import TextInputModal from "../components/common/TextInputModal";
import { useDispatch, useSelector } from "react-redux";
import {
  getMoneyRefund,
  getMoneyRefunds,
  postDownloadMoneyRefunds,
  putConfirmRefundMoneyRefunds,
  putMoneyRefunds,
  removeMoneyRefunds,
} from "../redux/Actions/money_refunds_action";
import { bank_options } from "../helpers/GlobalOptions";
import MoneyRefundOrderRowPreview from "../components/common/GlobalModals/Orders/editModal/Payments/MoneyRefundOrderRowPreview";
import { Bubble } from "../components/common/StyledComponents";
import { Modal } from "antd";
import Spinner from "../components/common/Spinner";
const { confirm } = Modal;
import { ExclamationCircleOutlined } from "@ant-design/icons";
import Axios from "axios";
import { onChangeNumber } from "../helpers/Input";
import useChecked from "../hooks/useChecked";
import MoneyRefundOrderCartRulesPreview from "../components/common/GlobalModals/Orders/editModal/Payments/MoneyRefundOrderCartRulesPreview";
import { Label } from "../components/globals";

const filterInitial = {
  bank_name: undefined,
  date: ["", ""],
  status: undefined,
};
export default function MoneyRefundsScreen({ match }) {
  const dispatch = useDispatch();
  const { totals, current, loading, data } = useSelector(
    (state) => state.custom
  );
  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState(filterInitial);
  const [filterString, setfilterString] = useState("");

  const [modalPreview, setModalPreview] = useState(false);

  useEffect(() => {
    console.log("2");
    dispatch(getMoneyRefunds(page, filterString));
  }, [filterString, page]);

  useEffect(() => {
    onFilter();
  }, [filters.bank_name, filters.date, filters.status]);

  const onFilter = () => {
    let filterParams = "";

    if (filters.bank_name)
      filterParams += `&q[bank_name_cont_any]=${filters.bank_name}`;
    if (filters.date.every((d) => d)) {
      filterParams += `&q[date_gteq]=${filters.date[0]}`;
      filterParams += `&q[date_lteq]=${filters.date[1]}`;
    }
    if (filters.status)
      filterParams += `&q[status_present]=${
        filters.status == "true" ? "1" : "0"
      }`;

    console.log(filterParams);

    setfilterString(filterParams);
    setPage(1);
  };

  return (
    <Container
      location={{
        locationName: "Refunds",
        locationUrl: match.url,
      }}
    >
      <ContentBlock>
        <FilterMenu
          totals={totals}
          length={data.length}
          text2="Refunds"
          countPage={50}
        />
      </ContentBlock>
      <ContentBlock>
        <TableFilterBox
          filter={false}
          add={false}
          clearFilter={() => setFilters(filterInitial)}
        >
          <div className="px-1">
            <SelectForm
              placeholder="Bank"
              dropdownMatchSelectWidth={false}
              style={{ width: 165 }}
              options={bank_options}
              onChange={(bank_name) =>
                setFilters((prev) => ({ ...prev, bank_name }))
              }
              value={filters.bank_name}
            />
          </div>
          <div className="px-1">
            <div className="form-group order-input-form-group">
              <Label className="text-sm-label">Date:</Label>
              <div>
                <RangePickerComp
                  style={{ width: 250 }}
                  placeholder={["Start time", "End time"]}
                  value={[
                    getDateFormat(filters.date[0]),
                    getDateFormat(filters.date[1]),
                  ]}
                  onChange={(_, date) =>
                    setFilters((prev) => ({ ...prev, date }))
                  }
                />
              </div>
            </div>
          </div>

          <div className="px-1" style={{ minWidth: "150px" }}>
            <SelectForm
              placeholder="Status"
              style={{ width: 165 }}
              dropdownMatchSelectWidth={false}
              options={[
                {
                  label: "All",
                  value: "",
                },
                {
                  label: "Closed",
                  value: "true",
                },
                {
                  label: "Not closed",
                  value: "false",
                },
              ]}
              onChange={(status) => setFilters((prev) => ({ ...prev, status }))}
              value={filters.status}
            />
          </div>
        </TableFilterBox>
        <div>
          <ContentValidation loader={loading} array={data}>
            <div className="table-responsive" style={{ overflow: "hidden" }}>
              <table className="table mt-3">
                <thead>
                  <tr className="text-muted">
                    <th className="text-black">Closed</th>
                    <th className="text-black">Refunded</th>
                    <th className="text-black">Store</th>
                    <th className="text-black">Bank</th>
                    <th className="text-black">Date</th>
                    <th className="text-black">No. of payments</th>
                    <th className="text-black">Totals</th>
                    <th className="text-black"></th>
                  </tr>
                </thead>
                <tbody>
                  {!loading &&
                    current == "Refunds" &&
                    data.map((item, idx) => {
                      return (
                        <MoneyRefundItem
                          key={item.id}
                          idx={idx}
                          modalFunc={setModalPreview}
                          {...item}
                        />
                      );
                    })}
                </tbody>
              </table>
              <Pagination
                page={1}
                pageCount={50}
                totals={totals}
                setPagination={setPage}
              />
            </div>
          </ContentValidation>
        </div>
      </ContentBlock>

      {typeof modalPreview == "number" && (
        <ModalMoneyRefund
          data={data[modalPreview]}
          modalFunc={setModalPreview}
        />
      )}
    </Container>
  );
}

const ModalMoneyRefund = ({ modalFunc, data }) => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const { onChangeChecked, checkedIncluded, checkedAll, setChecked, checked } =
    useChecked([]);

  useEffect(() => {
    dispatch(getMoneyRefund(data.id))
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <ModalSpecial onClose={() => modalFunc(false)}>
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ height: "100%" }}
        >
          <Spinner />
        </div>
      </ModalSpecial>
    );
  }
  const reduce_total = data.money_refund_item.reduce(
    (total, acc) => total + +acc.sum,
    0
  );
  const reduce_total_paid = data.money_refund_item.reduce(
    (total, acc) => total + +acc.order.total_paid,
    0
  );

  return (
    <ModalSpecial onClose={() => modalFunc(false)}>
      <div className="d-flex justify-content-between mb-3 align-items-center">
        <div className="text-xl">
          <span>
            Refund
            <span className="text-primary ml-2">{data.date}</span>
          </span>
        </div>
        <div className="d-flex align-items-center">
          {data.status && data.user_full ? (
            <div className="mr-3 text-primary">
              Closed by <b>{data.user_full}</b>
            </div>
          ) : null}
          <ConfirmPayment
            refund={data}
            checked={checked}
            setChecked={setChecked}
            download={true}
          />
          <XIcon
            className="text-sm cursor-pointer ml-3"
            onClick={() => modalFunc(false)}
          />
        </div>
      </div>
      <div className="d-flex">
        <div className="mr-4">
          <label className="text-bold my-1">Shop</label>
          <div>{data.store_name}</div>
        </div>{" "}
        <div className="mr-4">
          <label className="text-bold my-1">Bank</label>
          <div>{data.bank_name}</div>
        </div>
        <div>
          <label className="text-bold my-1">Date</label>
          <div>{data.date}</div>
        </div>
      </div>
      <hr
        style={{
          color: "#DFDFDF",
        }}
      />

      <TableUi
        ths={[
          <CheckBoxInput
            checked={checkedAll(
              data.money_refund_item
                .filter((item) => !item.status)
                .filter((item) => !item.bank_transaction_id)
                .map(({ id }) => id)
            )}
            onChange={() => {
              if (
                checkedAll(
                  data.money_refund_item
                    .filter((item) => !item.status)
                    .filter((item) => !item.bank_transaction_id)
                    .map(({ id }) => id)
                )
              ) {
                setChecked([]);
              } else {
                setChecked(
                  data.money_refund_item
                    .filter((item) => !item.status)
                    .filter((item) => !item.bank_transaction_id)
                    .map(({ id }) => id)
                );
              }
            }}
          />,
          "Status",
          "Order ID",
          "Invoice",
          "User",
          "Customer",
          "Reason",
          "Method of pamynet",
          "Bank account number",
          "",
          "Past order ref.",
          "Paid",
          "Totals",
          "",
        ]}
      >
        {data.money_refund_item.map((e) => {
          return (
            <MoneyRefundChildrenItem
              key={"money_refund_item_" + e.id}
              {...e}
              checkedIncluded={checkedIncluded(e.id)}
              onChangeChecked={() => onChangeChecked(e.id)}
            />
          );
        })}
        <TableUi.tr className={"bg-blue-light"}>
          <TableUi.td colspan={11}></TableUi.td>
          <TableUi.td colspan={1}>
            <b>{returnEuroString(reduce_total_paid)}</b>
          </TableUi.td>
          <TableUi.td colspan={2}>
            <b>{returnEuroString(reduce_total)}</b>
          </TableUi.td>
        </TableUi.tr>
      </TableUi>
      {data.api_error && (
        <div className="text-danger">Api error: {data.api_error}</div>
      )}
    </ModalSpecial>
  );
};

const ConfirmPayment = ({ refund, checked, setChecked, download = false }) => {
  const dispatch = useDispatch();
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const cleanUp = () => {
    setChecked([]);
    setLoading(false);
  };

  const onAction = async () => {
    try {
      setLoading(true);
      setConfirmLoading(true);
      if (download) {
        await dispatch(postDownloadMoneyRefunds(refund, checked));
      } else {
        await dispatch(putConfirmRefundMoneyRefunds(refund, checked));
      }
      return true;
    } catch (err) {
    } finally {
      cleanUp();
      setConfirmLoading(false);
      setMessage("");
    }
  };
  const checkAvailableRefunded = async () => {
    try {
      setLoading(true);
      const { data } = await Axios.get(
        `/api/v1/money_refunds/${refund.id}/has_already_refunded?${checked
          .map((num) => "&ids[]=" + num)
          .join("")}`
      );

      if (data.success) {
        let message = "";
        if (data.over_pay && !!data.id_orders.length) {
          message = `Are you sure you will refund more than the order amount and where orders used in another refund? (${data.id_orders.join(
            ", "
          )})`;
        } else if (!data.over_pay && !!data.id_orders.length) {
          message = `Are you sure you will refund orders used in another refund? (${data.id_orders.join(
            ", "
          )})`;
        } else if (data.over_pay) {
          message = "Are you sure you will refund more than the order amount? ";
        }
        if (!!message) {
          return setMessage(message);
        }
      }
      confirm({
        title: "Are you sure?",
        icon: <ExclamationCircleOutlined className="text-primary" />,
        content: "You will not be able to undo this action",
        onOk() {
          return new Promise(async (resolve) => {
            await onAction();
            resolve();
          });
        },
        onCancel() {
          console.log("Cancel 2");
        },
      });
    } catch (err) {
      console.log("ERROR: " + err);
    } finally {
      setLoading(false);
    }
  };

  if (!!message) {
    return (
      <Popconfirm
        placement="leftTop"
        visible={true}
        open={true}
        title={
          <div
            style={{
              width: 240,
            }}
          >
            {message}
          </div>
        }
        okButtonProps={{ loading: confirmLoading }}
        onConfirm={() => {
          onAction();
        }}
        onCancel={() => {
          setMessage("");
          console.log("Cancel");
          return true;
        }}
        okText="Yes"
        cancelText="No"
      >
        <button
          disabled={checked.length == 0 || loading}
          className="btn btn-primary text-sm mr-3 py-0"
          style={{
            height: 29,
            width: 120,
          }}
        >
          {loading ? (
            <span
              className="spinner-border spinner-border-sm"
              style={{ width: 15, height: 15 }}
            ></span>
          ) : download ? (
            <IconDownload color="#fff" />
          ) : (
            "Confirm refund"
          )}
        </button>
      </Popconfirm>
    );
  }
  return (
    <button
      disabled={checked.length == 0 || loading}
      className="btn btn-primary text-sm mr-3 py-0"
      style={{
        height: 29,
        width: 120,
      }}
      onClick={() => {
        checkAvailableRefunded();
      }}
    >
      {loading ? (
        <span
          className="spinner-border spinner-border-sm"
          style={{ width: 15, height: 15 }}
        ></span>
      ) : download ? (
        <IconDownload color="#fff" />
      ) : (
        "Confirm refund"
      )}
    </button>
  );
};

const MoneyRefundChildrenItem = ({
  status,
  bank_transaction_id,
  id,
  user_full,
  money_refund_id,
  customer,
  reason,
  bank_account,
  order_rows,
  order_row_items,
  order,
  sum,
  total_discount,
  total_product,
  send_to_rivile,
  refund_type,
  shipping,
  onChangeChecked,
  checkedIncluded,
  order_cart_rules_items,
  order_cart_rules,
  order_rows_cart_rules,
}) => {
  const dispatch = useDispatch();
  const [editing, setEditing] = useState(false);
  const [manualPreview, setManualPreview] = useState(false);
  const [editingVariables, setEditingVariables] = useState({});
  useEffect(() => {
    if (editing) {
      console.log({ editing, sum });
      setEditingVariables({
        reason,
        customer,
        bank_account,
        sum,
        order_rows: shipping > 0 ? ["delivery", ...order_rows] : order_rows,
        order_cart_rules,
        shipping,
        total_discount,
        total_product,
      });
    } else {
      setEditingVariables({
        reason: "",
        customer: "",
        bank_account: "",
        shipping: 0,
        sum: "",
        order_rows: [],
        order_cart_rules: [],
        total_discount: "",
        total_product: "",
      });
    }
  }, [editing]);

  useEffect(() => {
    if (editing) {
      oChange({
        target: {
          name: "sum",
          value:
            +editingVariables.total_product - +editingVariables.total_discount,
        },
      });
    }
  }, [editingVariables.total_discount, editingVariables.total_product]);

  const onSave = async () => {
    if (
      +editingVariables.sum <= 0 &&
      editingVariables.order_cart_rules.length > 0
    )
      return antdMessageError(
        "[Total amount]: It cannot be less than or equal to 0"
      );

    const params = {
      id,
      ...editingVariables,
      bank_account: editingVariables.bank_account.toUpperCase(),
    };
    if (shipping > 0) {
      if (params.order_rows.includes("delivery")) {
        params.order_rows = params.order_rows.filter((d) => d !== "delivery");
      } else {
        params.shipping = 0;
      }
    }
    const { success } = await dispatch(putMoneyRefunds(params));
    if (success) {
      setEditing(false);
      setManualPreview(false);
    }
  };

  const onDelete = async () => {
    confirm({
      title: "Are you sure?",
      icon: <ExclamationCircleOutlined className="text-primary" />,
      content: "You will not be able to undo this action",
      onOk() {
        dispatch(removeMoneyRefunds(id, money_refund_id));
        console.log("OK");
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const oChange = (e) => {
    const { name, value } = e.target;
    setEditingVariables((prev) => ({ ...prev, [name]: value }));
  };

  console.log({ editingVariables, sum });

  return (
    <>
      <TableUi.tr>
        <TableUi.td className="p-left">
          {status
            ? false
            : !bank_transaction_id && (
                <CheckBoxInput
                  checked={checkedIncluded}
                  onChange={onChangeChecked}
                />
              )}
        </TableUi.td>
        <TableUi.td>
          <Tooltip
            placement="top"
            title={
              <span className="text-sm">
                <div>Return status</div>
                {status ? (
                  <div className="text-success">Refunded</div>
                ) : (
                  <div className="text-danger">Not refunded</div>
                )}
              </span>
            }
          >
            <IconDot className={status ? "text-success" : "text-danger"} />
          </Tooltip>
        </TableUi.td>
        <TableUi.td>{order.id_order}</TableUi.td>
        <TableUi.td>
          {send_to_rivile ? (
            <Tooltip title={prettyDateFormat(send_to_rivile)}>
              <div>Sent</div>
            </Tooltip>
          ) : (
            "-"
          )}
        </TableUi.td>
        <TableUi.td>{user_full}</TableUi.td>
        <TableUi.td>
          {editing ? (
            <TextInputModal
              name="customer"
              value={editingVariables.customer}
              onChange={oChange}
            />
          ) : (
            customer
          )}
        </TableUi.td>
        <TableUi.td>
          {" "}
          {editing ? (
            <TextInputModal
              name="reason"
              value={editingVariables.reason}
              onChange={oChange}
            />
          ) : (
            reason
          )}
        </TableUi.td>
        <TableUi.td>{order.payment}</TableUi.td>
        <TableUi.td>
          {editing ? (
            <TextInputModal
              name="bank_account"
              value={editingVariables.bank_account}
              onChange={oChange}
            />
          ) : (
            bank_account
          )}
        </TableUi.td>
        <TableUi.td>
          {(!!order_rows.length || shipping > 0) && (
            <div className="mb-1 text-xs">
              Prod:
              <Bubble
                active={editing || manualPreview}
                onClick={() => setManualPreview((prev) => !prev)}
              >
                {shipping > 0 ? order_rows.length + 1 : order_rows.length}
              </Bubble>
            </div>
          )}
          {!!order_cart_rules.length && (
            <div className="text-xs">
              Dis:
              <Bubble
                active={editing || manualPreview}
                onClick={() => setManualPreview((prev) => !prev)}
              >
                {order_cart_rules.length}
              </Bubble>
            </div>
          )}
          {refund_type == "compensation" && (
            <div className="text-xs">Compensation</div>
          )}
        </TableUi.td>
        <TableUi.td>{returnEuroString(order.total_price)}</TableUi.td>
        <TableUi.td>{returnEuroString(order.total_paid)}</TableUi.td>
        <TableUi.td>
          {editing ? (
            <>
              <TextInputModal
                suffix="€"
                name="total_product"
                text="Total product/service"
                value={editingVariables.total_product}
                onChange={(e) => oChange(onChangeNumber(e))}
              />
              <TextInputModal
                suffix="€"
                name="total_discount"
                text="Total discount"
                value={editingVariables.total_discount}
                onChange={(e) => oChange(onChangeNumber(e))}
              />
              <TextInputModal
                disabled={true}
                suffix="€"
                text="Total"
                value={editingVariables.sum}
              />
            </>
          ) : (
            <div>
              <div className="text-sm">
                Total product/service: {returnEuroString(total_product)}
              </div>
              <div className="text-sm">
                Total discount: {returnEuroString(total_discount)}
              </div>
              <div className="text-sm">Total sum: {returnEuroString(sum)}</div>
            </div>
          )}
        </TableUi.td>
        <TableUi.td className={"align-middle"}>
          <div className="d-flex justify-content-end">
            {!status && !bank_transaction_id && (
              <>
                {editing ? (
                  <>
                    <button
                      className="btn btn-sm mr-1"
                      onClick={() => onSave()}
                      style={{
                        width: 29,
                        height: 29,
                      }}
                    >
                      <IconSave fill="#007BFF" className="text-xl" />
                    </button>
                    <button
                      className="btn btn-sm"
                      onClick={() => {
                        setEditing(false);
                        setManualPreview(false);
                      }}
                      style={{
                        width: 29,
                        height: 29,
                      }}
                    >
                      <IconTimes color="#EF3824" className="text-xl" />
                    </button>
                  </>
                ) : (
                  <>
                    {" "}
                    <button
                      className="btn btn-sm mr-2"
                      onClick={() => setEditing(true)}
                      style={{
                        width: 29,
                        height: 29,
                      }}
                    >
                      <IconEdit className="text-xl" />
                    </button>
                    <ButtonDelete onDelete={() => onDelete()} />
                  </>
                )}
              </>
            )}
          </div>
        </TableUi.td>
      </TableUi.tr>
      {(manualPreview || editing) && (
        <MoneyRefundChildrenItemEditing
          showCheck={editing}
          order_row_items={
            shipping > 0
              ? [
                  {
                    unit_price_tax_incl: shipping,
                    product_name: "Delivery",
                    id: "delivery",
                    quantity: 1,
                  },
                  ...order_row_items,
                ]
              : order_row_items
          }
          order_rows_selected={editingVariables.order_rows}
          order_cart_rules_items={order_cart_rules_items}
          order_cart_rules_selected={editingVariables.order_cart_rules}
          setEditingVariables={setEditingVariables}
          order_rows_cart_rules={order_rows_cart_rules}
        />
      )}
    </>
  );
};
const MoneyRefundChildrenItemEditing = ({
  order_row_items,
  order_rows_selected,
  setEditingVariables,
  showCheck,
  order_cart_rules_items,
  order_cart_rules_selected,
  order_rows_cart_rules,
}) => {
  return (
    <>
      <TableUi.tr>
        <TableUi.td className={"p-0"} colspan={14}>
          <div className="font-medium">Products</div>
        </TableUi.td>
      </TableUi.tr>
      <TableUi.tr>
        <TableUi.td className={"p-0"} colspan={14}>
          <div className="bg-light-primary rounded">
            <MoneyRefundOrderRowPreview
              order_cart_rules={order_rows_cart_rules}
              o_rows={order_row_items}
              order_rows_selected={order_rows_selected}
              setValue={
                showCheck
                  ? (val) => {
                      setEditingVariables((prev) => ({
                        ...prev,
                        total_product: val.sum,
                        order_rows: val.order_rows,
                      }));
                    }
                  : false
              }
            />
          </div>
        </TableUi.td>
      </TableUi.tr>
      {(!!order_cart_rules_selected.length ||
        !!order_cart_rules_items.length) && (
        <>
          <TableUi.tr>
            <TableUi.td className={"p-0"} colspan={14}>
              <div className="font-medium">Discounts</div>
            </TableUi.td>
          </TableUi.tr>
          <TableUi.tr>
            <TableUi.td className={"p-0"} colspan={14}>
              <div className="bg-light-primary rounded">
                <MoneyRefundOrderCartRulesPreview
                  order_cart_rules={order_cart_rules_items}
                  order_cart_rules_selected={order_cart_rules_selected}
                  setValue={
                    showCheck
                      ? (val) => {
                          setEditingVariables((prev) => ({
                            ...prev,
                            total_discount: val.sum,
                            order_cart_rules: val.order_cart_rules,
                          }));
                        }
                      : false
                  }
                />
              </div>
            </TableUi.td>
          </TableUi.tr>
        </>
      )}
    </>
  );
};

const MoneyRefundItem = ({
  id,
  status,
  item_statuses_length,
  store_name,
  bank_name,
  date,
  money_refund_item,
  modalFunc,
  idx,
  total_sum,
  total_length,
}) => {
  const dispatch = useDispatch();
  const { role } = useSelector((state) => state.auth.user);
  const items_total = useMemo(() => {
    if (!money_refund_item) return total_sum;
    let count_total_sum = {
      sum: 0,
      total_discount: 0,
      total_product: 0,
    };
    money_refund_item.forEach((cur) => {
      count_total_sum.sum += +cur.sum;
      count_total_sum.total_discount += +cur.total_discount;
      count_total_sum.total_product += +cur.total_product;
    });
    return count_total_sum;
  }, [money_refund_item]);

  const total = useMemo(() => {
    return money_refund_item?.length || total_length;
  }, [money_refund_item?.length || total_length]);
  return (
    <tr className="align-middle tableColumn">
      <td className="align-middle">
        <Tooltip
          placement="top"
          title={
            <span className="text-sm">
              <div>Status</div>
              {status ? (
                <div className="text-success">Closed</div>
              ) : (
                <div className="text-danger">Not closed</div>
              )}
            </span>
          }
        >
          <IconDot className={status ? "text-success" : "text-danger"} />
        </Tooltip>
      </td>
      <td
        className={`align-middle ${
          total > item_statuses_length ? "text-danger" : "text-success"
        }`}
      >
        {item_statuses_length}/{total}
      </td>
      <td className="align-middle">{store_name}</td>
      <td className="align-middle">{bank_name}</td>
      <td className="align-middle">{date}</td>
      <td className="align-middle">{total}</td>
      <td className="align-middle">
        <div>
          <div className="text-sm">
            Total product/service: {returnEuroString(items_total.total_product)}
          </div>
          <div className="text-sm">
            Total discount: {returnEuroString(items_total.total_discount)}
          </div>
          <div className="text-sm">
            Total sum: {returnEuroString(items_total.sum)}
          </div>
        </div>
      </td>
      <td className="align-middle d-flex justify-content-end">
        {status && role == "accounting" && (
          <ButtonSmall
            type="outline"
            onClick={() =>
              dispatch(
                postDownloadMoneyRefunds(
                  {
                    id,
                    bank_name,
                    date,
                  },
                  money_refund_item
                    .filter((item) => !item.status)
                    .filter((item) => !item.bank_transaction_id)
                    .map((d) => d.id)
                )
              )
            }
          >
            <IconDownload color="#007BFF" />
          </ButtonSmall>
        )}
        <ButtonSmall className={"ml-2"} onClick={() => modalFunc(idx)}>
          <IconSearch color="#fff" />
        </ButtonSmall>
      </td>
    </tr>
  );
};
